import { render, staticRenderFns } from "./PageBackgroundSettings.vue?vue&type=template&id=c1b54792"
import script from "./PageBackgroundSettings.vue?vue&type=script&lang=js"
export * from "./PageBackgroundSettings.vue?vue&type=script&lang=js"
import style0 from "./PageBackgroundSettings.vue?vue&type=style&index=0&id=c1b54792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports